<div class="search-container">
  <div class="search-wrapper">
    <div class="input-wrapper" [class.active]="query.length">
      <input
        type="text"
        autocomplete="off"
        placeholder="Busca una ubicación"
        aria-label="Ubicación"
        role="combobox"
        aria-autocomplete="list"
        [attr.aria-controls]="listId"
        [attr.aria-expanded]="open"
        [attr.aria-activedescendant]="open && activeIndex >= 0 ? listId + '-option-' + activeIndex : null"
        [value]="query"
        (click)="inputClick.emit()"
        (input)="onInput($event)"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (keydown)="onKeydown($event)" />
      @if (query.length) {
        <button type="button" class="clear-button right" aria-label="Borrar ubicación" (click)="clearQuery()"><i class="icon-cancel-fill"></i></button>
      }
    </div>
    <button type="button" class="search-button" aria-label="Buscar ubicación" [disabled]="!selectedSuggestion" (click)="search()"><i class="icon-search icon"></i></button>
  </div>
  @if (open) {
    @if (suggestions.length) {
      <ul [id]="listId" class="suggestion-panel" role="listbox" aria-label="Ubicaciones sugeridas">
        @for (suggestion of suggestions; track suggestion.label; let index = $index) {
          <li
            [id]="listId + '-option-' + index"
            role="option"
            [attr.aria-selected]="index === activeIndex"
            [class.active]="index === activeIndex"
            (mousedown)="$event.preventDefault()"
            (click)="select(suggestion)">
            {{ suggestion.label }}
          </li>
        }
      </ul>
    } @else {
      <div [id]="listId" class="suggestion-panel empty-results" role="status">No encontramos resultados para tu búsqueda.</div>
    }
  }
</div>
